import { createSlice } from "@reduxjs/toolkit";

interface position {
  xCoordinate: number;
  yCoordinate: number;
}

const INIT_STATE: {
  isVisible: boolean;
  position: position;
  isFullScreen: boolean;
  selectedModule: any;
  sidebarDisplay: boolean;
} = {
  isVisible: false,
  position: { xCoordinate: 0, yCoordinate: 0 },
  isFullScreen: false,
  selectedModule: null,
  sidebarDisplay: true
};

const LearningAssistanceSlice = createSlice({
  name: "LearningAssistanceSlice",
  initialState: INIT_STATE,
  reducers: {
    setVisibility(state, action) {
      state.isVisible = action.payload;
    },
    setPosition(state, action) {
      state.position = action.payload;
    },
    setFullScreen(state, action) {
      state.isFullScreen = action.payload;
    },
    setSelectedModule(state, action) {
      state.selectedModule = action.payload;
    },
    setSidebarDisplay(state, action) {
      state.sidebarDisplay = action.payload;
    }
  }
});

export default LearningAssistanceSlice;

export const LearningAssistanceSliceActions = LearningAssistanceSlice.actions;
